import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { Store } from '@ngxs/store';
import { map, takeUntil } from 'rxjs/operators';
import { LogService } from '../../core/logger';
import { RoutingService } from '../../core/navigation';
import { ReceiptState } from '../receipt/state';
import { ReceiptModel } from '../receipt/state/receipt.model';

@Injectable({
    providedIn: 'root',
})
export class NoReceiptGuard  implements OnDestroy {

    receipt$ = this.store.select<ReceiptModel>(ReceiptState.receipt);
    destroy$ = new Subject<void>();

    constructor(private routingService: RoutingService, private logger: LogService, private store: Store) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> {

        return this.receipt$.pipe(
            takeUntil(this.destroy$),
            map((receipt) => {
                if (!!receipt) {
                    return true;
                }
                else {
                    this.routingService.navigateToHome();
                    return false;       
                }
            })
        );   
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}